module.exports = __webpack_public_path__ + "img/E-WEB-Goal-1.a5de5f5b.png";